import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './AdminLayout.css';

export function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      <header className="admin-header">
        <div className="admin-header-content">
          <h1>Painel Administrativo</h1>
          <div className="user-info">
            <span>Olá, {user?.name}</span>
            <button onClick={handleLogout} className="logout-link">
              Sair
            </button>
          </div>
        </div>
      </header>

      <div className="admin-container">
        <nav className="admin-nav">
          <ul>
            <li>
              <Link to="/admin">Dashboard</Link>
            </li>
            <li>
              <Link to="/admin/articles">Gerenciar Artigos</Link>
            </li>
          </ul>
        </nav>

        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
} 